import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Input,
  Button,
  Row,
  Col,
  notification,
  Tabs,
  Modal,
  Image,
  Switch,
  DatePicker,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { FaTrash } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { FaInbox } from "react-icons/fa";
import {
  addInventory,
  resetIsInventoryAdded,
  getInventories,
} from "../../../toolkit/slices/inventories/inventorySlice";
import "./AddInventoryContainer.css";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import accessCheckPromise from "../../../../utils/accessCheck";
import canDeleteInventory from "../../../../utils/canDeleteInventory";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import AuthorizationError from "../AuthorizationError";
import convertS3ToCloudFront from "../../../../utils/convertS3ToCloudFront";
import { Table } from "antd";
import * as XLSX from "xlsx";
const { Option } = Select;

const normalizeSearchText = (str) =>
  str ? str.toLowerCase().replace(/\s+/g, "").trim() : "";

const filterInventoryBySearch = (data, searchValue) => {
  const trimmedValue = normalizeSearchText(searchValue);
  if (!trimmedValue) return data;
  return data.filter(
    (item) =>
      normalizeSearchText(item?.codeNo)?.includes(trimmedValue) ||
      normalizeSearchText(item?.city)?.includes(trimmedValue) ||
      normalizeSearchText(item?.area)?.includes(trimmedValue) ||
      normalizeSearchText(item?.zone)?.includes(trimmedValue) ||
      normalizeSearchText(item?.name)?.includes(trimmedValue) ||
      normalizeSearchText(item?.mediaType)?.includes(trimmedValue) ||
      normalizeSearchText(item?.Illu)?.includes(trimmedValue) ||
      item?.ratePerMonth?.toString()?.includes(trimmedValue),
  );
};

const AddInventoryContainer = () => {
  const [previewURLs, setPreviewURLs] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [flag, setFlag] = useState(false);
  const [getInvToggle, setGetInvToggle] = useState(false);
  const dispatch = useDispatch();
  const [initialInv, setInitialInv] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentInventory, setCurrentInventory] = useState(null);
  const [currentInventoryId, setCurrentInventoryId] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteInventoryId, setDeleteInventoryId] = useState(null);
  const [deleteRemovedOn, setDeleteRemovedOn] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isTrading, setIsTrading] = useState(false);
  const [isTradingDataFetched, setIsTradingDataFetched] = useState(false);
  const inventories = useSelector((state) =>
    isTrading ? [] : state.inventoriesList.inventories,
  );
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [originalDataSource, setOriginalDataSource] = useState([]);
  const [form] = Form.useForm();
  let userId = useSelector((state) => state.user._id);
  const [users, setUsers] = useState([]);
  const [access, setAccess] = useState(false);

  // console.log("User ID is: ", userId);
  const [bulkUpdateModalVisible, setBulkUpdateModalVisible] = useState(false);
  const [bulkExcelFile, setBulkExcelFile] = useState(null);
  const [bulkExcelData, setBulkExcelData] = useState([]);
  const [bulkExcelFileName, setBulkExcelFileName] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  // 2. Add this handler function (around line 130, before the renderTabContent function):
  const openBulkUpdateModal = () => {
    setBulkUpdateModalVisible(true);
  };

  const closeBulkUpdateModal = () => {
    setBulkUpdateModalVisible(false);
    setBulkExcelFile(null);
    setBulkExcelData([]);
    setBulkExcelFileName("");
    setShowPreview(false);
  };
  useEffect(() => {
    fetchUsersForYellowSpot();
  }, []);

  const handleBulkExcelUpload = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];

    if (!allowedTypes.includes(file.type)) {
      notification.error({
        message: "Please upload a valid Excel file (.xls, .xlsx, or .csv)",
      });
      event.target.value = null;
      return;
    }

    setBulkExcelFileName(file.name);
    setBulkExcelFile(file);

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      setBulkExcelData(json);
      setShowPreview(true);
      notification.success({
        message: "Excel file uploaded successfully!",
      });
    } catch (err) {
      console.error("Failed to parse excel", err);
      notification.error({ message: "Failed to parse Excel file." });
      setBulkExcelData([]);
      setBulkExcelFileName("");
    }

    event.target.value = null;
  };
  const handleBulkUpdate = async () => {
    try {
      // Map Excel data to backend format - matching your Excel column names
      const updates = bulkExcelData.map((row) => ({
        codeNo: row["Code No."].trim(),
        ratePerMonth: row["New Rate"],
      }));

      console.log("Excel Data from file:", bulkExcelData);
      console.log("Transformed updates:", updates);

      // Filter out invalid entries
      const validUpdates = updates.filter(
        (item) => item.codeNo && item.ratePerMonth > 0,
      );

      if (validUpdates.length === 0) {
        notification.error({
          message: "No Valid Data",
          description:
            "No valid updates found in the Excel file. Please check the data.",
        });
        return;
      }

      // Send to backend
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/inventoryManagement/updatebulkExcel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ updates: validUpdates }),
        },
      );

      const result = await response.json();
      console.log("Backend response:", result);

      if (result.success) {
        notification.success({
          message: "Bulk Update Successful",
          description: `${result.matched} inventories matched, ${result.modified} updated successfully.`,
          duration: 5,
        });

        // Refresh the inventory list
        // setGetInvToggle((prev) => !prev);
        if (isTrading) {
          await fetchTradingInventories();
        } else {
          dispatch(getInventories());
        }

        // Close modal and reset state
        closeBulkUpdateModal();
      } else {
        notification.error({
          message: "Bulk Update Failed",
          description: result.message || "Failed to update inventories.",
        });
      }
    } catch (error) {
      console.error("Error during bulk update:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while updating inventories.",
      });
    }
  };
  async function fetchUsersForYellowSpot() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getUsersWithModules`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      let responseJson = await response.json();
      setUsers(responseJson.data);
    } catch (error) {
      console.error(`Error fetching users: ${error.message}`);
    }
  }

  console.log("Users are: ", users);

  useEffect(() => {
    if (!isTrading) {
      dispatch(getInventories());
    }
  }, [isTrading, getInvToggle]);

  const fetchTradingInventories = async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllTradingInventories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        },
      );

      const data = await response.json();

      console.log("Data is: ", data);
      if (data.success) {
        const mappedTradingInventories = data.allTradingInventories.map(
          (inventory) => ({
            key: inventory?._id,
            id: inventory?._id,
            codeNo: inventory?.CodeNo,
            city: inventory?.locations?.city,
            area: inventory?.locations?.Area,
            zone: inventory?.locations?.zone,
            name: inventory?.locations?.name,
            Illu: inventory?.Illu,
            ratePerMonth: inventory?.ratePerMonth,
            mediaType: inventory?.typeOfMedia?.name,
            // ownedBy: inventory?.ownedBy || "-",
            width: inventory?.width,
            height: inventory?.height,
            lat: inventory?.lat,
            lng: inventory?.lng,
            img: inventory?.img,
          }),
        );

        setOriginalDataSource(mappedTradingInventories);
        setFilteredDataSource(
          filterInventoryBySearch(mappedTradingInventories, searchText),
        );
        setIsTradingDataFetched(true);
      } else {
        notification.error({
          message: data.error || "Failed to fetch trading inventories.",
        });
      }
    } catch (error) {
      notification.error({
        message: "API call failed. Please try again later.",
      });
      console.error("API call failed:", error);
    }
  };

  useEffect(() => {
    if (flag) {
      handleFileSelectOfPreview();
    }
  }, [flag]);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        console.log("this is the error", error.message);
        dispatch(logoutUser());
      });
  }, []);

  const handleFileSelectOfPreview = async () => {
    try {
      for (const file of selectedFiles) {
        if (!file) continue;

        const fileType = file.type;
        const requestBody = {
          fileName: encodeURIComponent(file.name),
          mime: fileType,
          "Content-Type": fileType,
          acl: "public-read",
        };

        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        const data = await response.json();

        if (data?.data?.fields && data?.data?.url) {
          const formData = new FormData();

          // Ensure Content-Type is set correctly for S3 policy
          const expectedContentType = fileType || "image/jpeg";

          Object.entries(data.data.fields).forEach(([key, value]) => {
            // Override Content-Type or mime if present to ensure exact match
            if (
              key.toLowerCase() === "content-type" ||
              key.toLowerCase() === "mime"
            ) {
              formData.append(key, expectedContentType);
            } else {
              formData.append(key, value);
            }
          });

          // Ensure Content-Type is set even if not in fields, but only if mime is also missing
          if (
            !formData.has("Content-Type") &&
            !formData.has("content-type") &&
            !formData.has("mime")
          ) {
            formData.append("Content-Type", expectedContentType);
          }

          formData.append("file", file);

          const uploadResponse = await fetch(data.data.url, {
            method: "POST",
            body: formData,
          });

          if (uploadResponse.ok) {
            const finalUrl = convertS3ToCloudFront(
              `${data.data.url}/${encodeURIComponent(data.filePath)}`,
            );
            console.log("File uploaded successfully to:", finalUrl);
            setImageUrl(finalUrl);
            setPreviewURLs((prev) => [...prev, finalUrl]);
            form.setFieldsValue({ img: finalUrl });
          } else {
            console.error("Error while uploading file");
          }
        }
      }
    } catch (error) {
      console.error("An error occurred during file upload:", error);
    }
  };

  const [activeTab, setActiveTab] = useState("1");
  const onChange = (key) => {
    setActiveTab(key);
  };

  const items = [
    { key: "1", label: "Add New Inventory" },
    { key: "2", label: "All Inventories" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return (
          <TabContent1
            setActiveTab={setActiveTab}
            setGetInvToggle={setGetInvToggle}
            isTrading={isTrading}
          />
        );
      case "2":
        return (
          <div>
            {filteredDataSource.length > 0 ? (
              <Table
                dataSource={filteredDataSource}
                columns={columns}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: [10, 20, 50],
                  total: filteredDataSource.length,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                  },
                }}
                scroll={{ x: 1200 }}
                components={{
                  header: {
                    cell: CustomHeaderCell,
                  },
                }}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  justifyContent: "center",
                  fontSize: "2rem",
                  fontWeight: "600",
                  color: "gray",
                }}
              >
                <FaInbox /> No inventories!
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const CustomHeaderCell = (props) => (
    <th {...props} style={{ backgroundColor: "#daeffe" }}>
      {props.children}
    </th>
  );

  useEffect(() => {
    if (isTrading && !isTradingDataFetched) {
      fetchTradingInventories();
    } else if (!isTrading) {
      setIsTradingDataFetched(false);
      const mappedInventories = inventories?.map((inventory) => ({
        key: inventory?._id,
        id: inventory?._id,
        codeNo: inventory?.CodeNo,
        city: inventory?.locations?.city,
        area: inventory?.locations?.Area,
        zone: inventory?.locations?.zone,
        name: inventory?.locations?.name,
        Illu: inventory?.Illu,
        ratePerMonth: inventory?.ratePerMonth,
        mediaType: inventory?.typeOfMedia?.name,
        // ownedBy: inventory?.ownedBy || "-",
        width: inventory?.width,
        height: inventory?.height,
        lat: inventory?.lat,
        lng: inventory?.lng,
        img: inventory?.img,
        fullId: inventory?.fullId,
        half1Id: inventory?.half1Id,
        half2Id: inventory?.half2Id,
      }));

      setOriginalDataSource(mappedInventories);
      setFilteredDataSource(
        filterInventoryBySearch(mappedInventories, searchText),
      );
    }
  }, [isTrading, inventories]);

  console.log("inventories: ", inventories);

  const handleToggle = (checked) => {
    setIsTrading(checked);
  };

  const columns = [
    {
      title: "Code No",
      dataIndex: "codeNo",
      key: "codeNo",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 140,
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      width: 140,
    },
    ...(isTrading
      ? []
      : [
        {
          title: "Zone",
          dataIndex: "zone",
          key: "zone",
          width: 80,
        },
      ]),
    {
      title: "Location",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Media Type",
      dataIndex: "mediaType",
      key: "mediaType",
    },
    {
      title: "Illumination",
      dataIndex: "Illu",
      key: "Illu",
    },
    {
      title: "Rate per month",
      dataIndex: "ratePerMonth",
      key: "ratePerMonth",
    },
    // {
    //   title: "Owned by",
    //   dataIndex: "ownedBy",
    //   key: "ownedBy",
    // },
    ...(isTrading
      ? []
      : [
        {
          title: "Full Code",
          dataIndex: "fullCode",
          key: "fullCode",
          align: "center",
          render: (text, record) => record?.fullId?.CodeNo || "-",
        },
        {
          title: "Half1 Code",
          dataIndex: "half1Code",
          key: "half1Code",
          align: "center",
          render: (text, record) => record?.half1Id?.CodeNo || "-",
        },
        {
          title: "Half2 Code",
          dataIndex: "half2Code",
          key: "half2Code",
          align: "center",
          render: (text, record) => record?.half2Id?.CodeNo || "-",
        },
      ]),
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <span style={{ display: "flex" }}>
          <MdEdit
            style={{ cursor: "pointer", marginRight: "1.5rem" }}
            size={18}
            onClick={() => handleEdit(record.id)}
          />
          {canDeleteInventory(userId) && (
            <FaTrash
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => openDeleteModal(record.id)}
            />
          )}
        </span>
      ),
    },
  ];

  const handleEdit = (id) => {
    console.log("Edit inventory with ID:", id);

    const selectedInventory = filteredDataSource.find(
      (item) => item?.id === id,
    );
    console.log("Selected Inventory:", selectedInventory);
    setCurrentInventory(selectedInventory);
    setCurrentInventoryId(id);

    setInitialInv({
      CodeNo: selectedInventory?.codeNo,
      city: selectedInventory?.city,
      Area: selectedInventory?.area,
      zone: selectedInventory?.zone,
      name: selectedInventory?.name,
      typeOfMedia: selectedInventory?.mediaType,
      Illu: selectedInventory?.Illu,
      ratePerMonth: selectedInventory?.ratePerMonth,
      // ownedBy: selectedInventory?.ownedBy || "-",
      width: selectedInventory?.width,
      height: selectedInventory?.height,
      lat: selectedInventory?.lat,
      lng: selectedInventory?.lng,
      img: selectedInventory?.img,
      half1Id: selectedInventory?.half1Id?.CodeNo,
      half2Id: selectedInventory?.half2Id?.CodeNo,
    });

    form.setFieldsValue({
      CodeNo: selectedInventory?.codeNo,
      city: selectedInventory?.city,
      Area: selectedInventory?.area,
      zone: selectedInventory?.zone,
      name: selectedInventory?.name,
      typeOfMedia: selectedInventory?.mediaType,
      Illu: selectedInventory?.Illu,
      ratePerMonth: selectedInventory?.ratePerMonth,
      // ownedBy: selectedInventory?.ownedBy || "-",
      width: selectedInventory?.width,
      height: selectedInventory?.height,
      lat: selectedInventory?.lat,
      lng: selectedInventory?.lng,
      img: selectedInventory?.img,
      half1Id: selectedInventory?.half1Id?.CodeNo,
      half2Id: selectedInventory?.half2Id?.CodeNo,
    });

    setImageUrl(selectedInventory?.img);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setCurrentInventoryId(null);
    setImageUrl(null);
  };

  const handleSave = async (values) => {
    const trimmedValues = {};

    Object.keys(values).forEach((key) => {
      const value = values[key];

      if (typeof value === "string") {
        trimmedValues[key] = value.trim();
      } else if (typeof value === "number" || !isNaN(value)) {
        trimmedValues[key] = value;
      } else {
        trimmedValues[key] = value;
      }
    });

    const updatedValues = {};

    Object.keys(trimmedValues).forEach((key) => {
      if (initialInv[key] !== trimmedValues[key]) {
        updatedValues[key] = trimmedValues[key];
      }
    });

    if (Object.keys(updatedValues).length === 0) {
      notification.success({
        message: "No changes detected. Nothing to update.",
      });
      return;
    }

    console.log("Updated values: ", updatedValues);

    const requestBody = {
      id: currentInventoryId,
      values: updatedValues,
    };

    console.log("requestBody is: ", requestBody);

    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/editInventory`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();
      if (data.success) {
        notification.success({
          message: "Inventory updated successfully.",
        });
        setGetInvToggle((prev) => !prev);
        if (isTrading) {
          fetchTradingInventories();
        }
      } else {
        notification.error({
          message: data.message || "Failed to update inventory.",
        });
        console.error("Error updating inventory:", data.message);
      }
    } catch (error) {
      notification.error({
        message: "API call failed. Please try again later.",
      });
      console.error("API call failed:", error);
    }

    form.resetFields();
    setIsModalVisible(false);
  };

  const openDeleteModal = (id) => {
    setDeleteInventoryId(id);
    setDeleteRemovedOn(null);
    setDeleteModalVisible(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
    setDeleteInventoryId(null);
    setDeleteRemovedOn(null);
  };

  const handleDelete = async () => {
    if (!deleteRemovedOn) {
      notification.warning({
        message: "Please select Removed On date.",
      });
      return;
    }

    try {
      setIsDeleting(true);
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteInventory`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            id: deleteInventoryId,
            removedOn: deleteRemovedOn.startOf("day").toISOString(),
          }),
        },
      );

      const data = await response.json();
      if (data.success) {
        notification.success({
          message: "Inventory deleted successfully.",
        });
        closeDeleteModal();
        setGetInvToggle((prev) => !prev);
        if (isTrading) {
          fetchTradingInventories();
        }
      } else {
        notification.error({
          message: data.message || "Failed to delete inventory.",
        });
        console.error("Error deleting inventory:", data.message);
      }
    } catch (error) {
      notification.error({
        message: "API call failed. Please try again later.",
      });
      console.error("API call failed:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleFileChange = async (event) => {
    try {
      const files = Array.from(event.target.files);
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/heic",
        // Add more MIME types as needed
      ];

      const hasNonAllowedType = files.some(
        (file) => !allowedTypes.includes(file.type),
      );

      if (hasNonAllowedType) {
        notification.error({
          message: "Only image is allowed!",
        });
        return;
      }

      for (const file of files) {
        const fileType = file.type;
        const requestBody = {
          fileName: encodeURIComponent(file.name),
          mime: fileType,
          "Content-Type": fileType,
          acl: "public-read",
        };

        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        const data = await response.json();

        if (data?.data?.fields && data?.data?.url) {
          const formData = new FormData();

          // Ensure Content-Type is set correctly for S3 policy
          const expectedContentType = fileType || "image/jpeg";

          Object.entries(data.data.fields).forEach(([key, value]) => {
            // Override Content-Type or mime if present to ensure exact match
            if (
              key.toLowerCase() === "content-type" ||
              key.toLowerCase() === "mime"
            ) {
              formData.append(key, expectedContentType);
            } else {
              formData.append(key, value);
            }
          });

          // Ensure Content-Type is set even if not in fields, but only if mime is also missing
          if (
            !formData.has("Content-Type") &&
            !formData.has("content-type") &&
            !formData.has("mime")
          ) {
            formData.append("Content-Type", expectedContentType);
          }

          formData.append("file", file);

          const uploadResponse = await fetch(data.data.url, {
            method: "POST",
            body: formData,
          });

          if (uploadResponse.ok) {
            const finalUrl = convertS3ToCloudFront(
              `${data.data.url}/${encodeURIComponent(data.filePath)}`,
            );
            setImageUrl(finalUrl);
            setPreviewURLs((prev) => [...prev, finalUrl]);
            form.setFieldsValue({ img: finalUrl });
          } else {
            console.error("Error while uploading file");
          }
        }
      }
    } catch (error) {
      console.error("An error occurred during file upload:", error);
      notification.error({ message: "An error occurred during file upload" });
    }
  };

  const handleImageUpload = () => {
    document.getElementById("imageUploadInput").click();
  };

  const handleSearch = (value) => {
    const trimmedValue = normalizeSearchText(value);
    setSearchText(trimmedValue);
    setFilteredDataSource(
      filterInventoryBySearch(originalDataSource, trimmedValue),
    );
  };

  console.log("currentInventory is: ", currentInventory);

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  if (!access) {
    return <AuthorizationError />;
  }

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: activeTab === "2" ? "20px" : 0,
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={onChange}
          items={items}
        />
        {activeTab === "2" && (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

            <Button style={{ display: "flex", alignItems: "center", gap: "2px" }} onClick={openBulkUpdateModal} type="primary">
              <UploadOutlined />
              Bulk Update Rate Per Month
            </Button>
            <Switch
              checked={isTrading}
              onChange={handleToggle}
              checkedChildren="Trading Inventories"
              unCheckedChildren="Show Trading"
            />
            <Input.Search
              placeholder="Search Inventory"
              onSearch={handleSearch}
              style={{ width: 300 }}
              allowClear
            />
          </div>
        )}
      </div>
      {renderTabContent()}
      <Modal
        title="Delete Inventory"
        open={deleteModalVisible}
        onCancel={closeDeleteModal}
        onOk={handleDelete}
        okText="Delete"
        okButtonProps={{ danger: true, loading: isDeleting }}
        cancelButtonProps={{ disabled: isDeleting }}
        destroyOnClose
      >
        <p style={{ marginBottom: 12 }}>
          Select the Removed On date for this inventory.
        </p>
        <div style={{ marginBottom: 8 }}>
          Removed On <span style={{ color: "red" }}>*</span>
        </div>
        <DatePicker
          style={{ width: "100%" }}
          format="DD-MM-YYYY"
          value={deleteRemovedOn}
          onChange={(date) => setDeleteRemovedOn(date)}
        />
      </Modal>
      <Modal
        title="Upload Excel"
        open={bulkUpdateModalVisible}
        onCancel={closeBulkUpdateModal}
        footer={[
          <Button
            key="update"
            type="primary"
            onClick={handleBulkUpdate}
            disabled={!bulkExcelData || bulkExcelData.length === 0}
          >
            Update
          </Button>,
        ]}
        width={900}
      >
        <div>
          <p style={{ marginBottom: 16 }}>
            <strong>Note:</strong> Excel format should be like this{" "}
            <a
              href="/Excel/RatePerMonthBulkUpload.xlsx"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1890ff", textDecoration: "underline" }}
              download
            >
              Sample Excel Format
            </a>
          </p>

          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleBulkExcelUpload}
              style={{ width: "100%" }}
            />
          </div>

          {bulkExcelFileName && (
            <div
              style={{ marginBottom: 16, fontWeight: 600, color: "#52c41a" }}
            >
              Uploaded: {bulkExcelFileName}
            </div>
          )}

          {bulkExcelData && bulkExcelData.length > 0 && showPreview && (
            <div style={{ marginTop: 20 }}>
              <div style={{ maxHeight: 400, overflow: "auto", marginTop: 16 }}>
                <Table
                  dataSource={bulkExcelData.map((row, index) => ({
                    key: index,
                    ...row,
                  }))}
                  columns={Object.keys(bulkExcelData[0]).map((columnKey) => ({
                    title: columnKey,
                    dataIndex: columnKey,
                    key: columnKey,
                    render: (value) =>
                      value === null || value === undefined
                        ? ""
                        : String(value),
                  }))}
                  pagination={false}
                  size="small"
                  scroll={{ x: 400 }}
                  bordered
                  components={components}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>

      {currentInventory && (
        <Modal
          title={
            <div style={{ textAlign: "center", marginBottom: "2rem" }}>
              Edit Inventory
            </div>
          }
          open={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              form="editInventoryForm"
              htmlType="submit"
            >
              Save
            </Button>,
          ]}
          width={800}
        >
          <Form form={form} id="editInventoryForm" onFinish={handleSave}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Code No"
                  name="CodeNo"
                  rules={
                    isTrading
                      ? []
                      : [{ required: true, message: "Code No is required!" }]
                  }
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="City"
                  name="city"
                  rules={[{ required: true, message: "City is required!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Area"
                  name="Area"
                  rules={[{ required: true, message: "Area is required!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              {!isTrading && (
                <Col span={12}>
                  <Form.Item
                    label="Zone"
                    name="zone"
                    rules={[{ required: true, message: "Zone is required!" }]}
                  >
                    <Select placeholder="Please select zone">
                      <Select.Option value="Centre">Centre</Select.Option>
                      <Select.Option value="East">East</Select.Option>
                      <Select.Option value="West">West</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Location"
                  name="name"
                  rules={[{ required: true, message: "Location is required!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Media Type"
                  name="typeOfMedia"
                  rules={[
                    { required: true, message: "Media Type is required!" },
                  ]}
                >
                  <Select>
                    <Select.Option value="Gantry">Gantry</Select.Option>
                    <Select.Option value="Unipole">Unipole</Select.Option>
                    <Select.Option value="Hoarding">Hoarding</Select.Option>
                    <Select.Option value="Cantilever">Cantilever</Select.Option>
                    <Select.Option value="LED">LED</Select.Option>
                    <Select.Option value="Kiosk">Kiosk</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Illumination"
                  name="Illu"
                  rules={[
                    { required: true, message: "Illumination is required!" },
                  ]}
                >
                  <Select>
                    <Select.Option value="FL">FL</Select.Option>
                    <Select.Option value="BL">BL</Select.Option>
                    <Select.Option value="NL">NL</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Rate per month"
                  name="ratePerMonth"
                  rules={[
                    { required: true, message: "Rate per month is required!" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                {/* <Form.Item
                  label="Owned by"
                  name="ownedBy"
                  rules={
                    isTrading
                      ? []
                      : [{ required: true, message: "Owned by is required!" }]
                  }
                >
                  <Input />
                </Form.Item> */}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Height"
                  name="height"
                  rules={[{ required: true, message: "Height is required!" }]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Width"
                  name="width"
                  rules={[{ required: true, message: "Width is required!" }]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Latitude"
                  name="lat"
                  rules={
                    isTrading
                      ? []
                      : [{ required: true, message: "Latitude is required!" }]
                  }
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Longitude"
                  name="lng"
                  rules={
                    isTrading
                      ? []
                      : [{ required: true, message: "Longitude is required!" }]
                  }
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>

            {!isTrading && !currentInventory?.fullId && (
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Half1 Code" name="half1Id">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Half1 Code"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {inventories
                        ?.filter(
                          (inventory) =>
                            inventory.CodeNo !== currentInventory?.codeNo,
                        )
                        .map((inventory) => (
                          <Select.Option
                            key={inventory._id}
                            value={inventory._id}
                          >
                            {inventory.CodeNo}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Half2 Code" name="half2Id">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Half2 Code"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {inventories
                        ?.filter(
                          (inventory) =>
                            inventory.CodeNo !== currentInventory?.codeNo,
                        )
                        .map((inventory) => (
                          <Select.Option
                            key={inventory._id}
                            value={inventory._id}
                          >
                            {inventory.CodeNo}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Form.Item
              label="Image"
              name="img"
              rules={
                isTrading
                  ? []
                  : [{ required: true, message: "Image is required!" }]
              }
            >
              <Input
                type="file"
                id="imageUploadInput"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <Button
                onClick={handleImageUpload}
                type="primary"
                style={{ marginBottom: "1rem" }}
              >
                Update Image
              </Button>
              {imageUrl && (
                <Image
                  src={convertS3ToCloudFront(imageUrl)}
                  alt="Image Preview"
                  style={{ marginTop: 10, maxWidth: "100%" }}
                />
              )}
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default AddInventoryContainer;

const TabContent1 = ({ setGetInvToggle, isTrading = false }) => {
  const [previewURLs, setPreviewURLs] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [flag, setFlag] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isInventoryAdded = useSelector(
    (state) => state.inventoriesList.isInventoryAdded,
  );
  //   const inventories = useSelector(state=>state.inventoriesList.inventories);
  const [selectedImage, setSelectedImage] = useState(null);
  const [codeNosList, setCodeNosList] = useState([]);
  const [selectedCodeNoInvId, setSelectedCodeNoInvId] = useState(null);
  const [fieldsDisabledByCodeNo, setFieldsDisabledByCodeNo] = useState(false);
  const [loadingCodeNos, setLoadingCodeNos] = useState(false);
  const [loadingInvInfo, setLoadingInvInfo] = useState(false);

  const onFinish = async (values) => {
    if (isUploading) {
      notification.info({
        message: "Please wait for image upload to complete.",
      });
      return;
    }
    // Helper function to trim and validate inputs
    const trimAndValidate = (input) => {
      if (typeof input === "string") {
        const trimmed = input.trim();
        return trimmed.length > 0 ? trimmed : null;
      }
      return input;
    };

    // Update existing inventory (Code No was selected)
    if (selectedCodeNoInvId) {
      if (!imageUrl) {
        notification.error({
          message: "Image is required for update.",
        });
        return;
      }
      const latNum =
        values.lat != null && values.lat !== ""
          ? Number(values.lat)
          : undefined;
      const lngNum =
        values.lng != null && values.lng !== ""
          ? Number(values.lng)
          : undefined;
      const rateNum =
        values.ratePerMonth != null && values.ratePerMonth !== ""
          ? Number(values.ratePerMonth)
          : undefined;
      const body = {
        invId: selectedCodeNoInvId,
        lat: latNum,
        long: lngNum,
        // ownedBy: trimAndValidate(values.ownedBy) ?? undefined,
        ratePerMonth: rateNum,
        zone: trimAndValidate(values.zone) ?? undefined,
        img: imageUrl,
        suffix: trimAndValidate(values?.suffix) ?? undefined,
      };
      try {
        const token = window.localStorage.getItem("token");
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/updateInvInfo`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${token}`,
            },
            body: JSON.stringify(body),
          },
        );
        const result = await response.json();
        if (result.success) {
          notification.success({
            message: "Success",
            description: result.message || "Inventory updated successfully.",
          });
          form.resetFields();
          setSelectedCodeNoInvId(null);
          setFieldsDisabledByCodeNo(false);
          setSelectedImage(null);
          setImageUrl(null);
          setSelectedFiles([]);
          setPreviewURLs([]);
          setGetInvToggle((prev) => !prev);
          fetchAllCodeNos();
        } else {
          notification.error({
            message: "Error",
            description: result.message || "Failed to update inventory.",
          });
        }
      } catch (err) {
        notification.error({
          message: "Error",
          description: err.message || "Failed to update inventory.",
        });
      }
      return;
    }

    // Add new inventory (no Code No selected)
    const trimmedValues = {
      city: trimAndValidate(values.city),
      area: trimAndValidate(values.area),
      zone: trimAndValidate(values.zone),
      name: trimAndValidate(values.name),
      illu: trimAndValidate(values.illu),
      width: trimAndValidate(values.width),
      height: trimAndValidate(values.height),
      lat: trimAndValidate(values.lat),
      lng: trimAndValidate(values.lng),
      unit: trimAndValidate(values.unit),
      mediaType: trimAndValidate(values.mediaType),
      // codeNo and casCode - not needed; code no from Select Code No
      // codeNo: trimAndValidate(values.codeNo),
      // casCode: trimAndValidate(values.casCode),
      // ownedBy: trimAndValidate(values.ownedBy),
      ratePerMonth: trimAndValidate(values.ratePerMonth),
      suffix: trimAndValidate(values?.suffix),
    };

    if (!imageUrl) {
      notification.error({
        message: "Can't create an inventory without images!",
      });
      return;
    }

    if (
      !trimmedValues.city ||
      !trimmedValues.area ||
      (!isTrading && !trimmedValues.zone) ||
      !trimmedValues.name
    ) {
      const requiredFields = isTrading
        ? "City, Area, and Name are required fields!"
        : "City, Area, Zone, and Name are required fields!";
      notification.error({
        message: requiredFields,
      });
      return;
    }

    let data = {
      locations: {
        city: trimmedValues.city,
        Area: trimmedValues.area,
        ...(isTrading ? {} : { zone: trimmedValues.zone }),
        name: trimmedValues.name,
      },
      Illu: trimmedValues.illu,
      width: trimmedValues.width,
      height: trimmedValues.height,
      lat: trimmedValues.lat,
      lng: trimmedValues.lng,
      unit: trimmedValues.unit,
      typeOfMedia: trimmedValues.mediaType,
      img: imageUrl,
      // CodeNo and CASCode - not sent; code no from Select Code No
      // CodeNo: trimmedValues.codeNo,
      // CASCode: trimmedValues.casCode,
      // ownedBy: trimmedValues.ownedBy,
      ratePerMonth: trimmedValues.ratePerMonth,
      suffix: trimmedValues.suffix,
    };

    dispatch(addInventory(data));
    form.resetFields();
    setSelectedImage(null);
    setImageUrl(null);
    setSelectedFiles([]);
    setPreviewURLs([]);
    setGetInvToggle((prev) => !prev);
  };

  useEffect(() => {
    if (isInventoryAdded) {
      notification.success({
        message: "Inventory added successfully",
        onClose: () => {
          dispatch(resetIsInventoryAdded());
        },
      });
    }
  }, [isInventoryAdded, dispatch]);

  const handleUpload = () => {
    document.querySelector(".add-inventory-image-upload input").click();
  };

  useEffect(() => {
    dispatch(getInventories());
  }, []);

  const fetchAllCodeNos = async () => {
    setLoadingCodeNos(true);
    try {
      const token = window.localStorage.getItem("token");
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllCodeNos`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${token}`,
          },
        },
      );
      const result = await response.json();
      if (result.success && Array.isArray(result.data)) {
        setCodeNosList(result.data);
      } else {
        setCodeNosList([]);
      }
    } catch (err) {
      console.error("Failed to fetch code nos:", err);
      setCodeNosList([]);
    } finally {
      setLoadingCodeNos(false);
    }
  };

  useEffect(() => {
    fetchAllCodeNos();
  }, []);

  const handleCodeNoSelect = async (invId) => {
    if (!invId) {
      setSelectedCodeNoInvId(null);
      setFieldsDisabledByCodeNo(false);
      form.resetFields();
      return;
    }
    setLoadingInvInfo(true);
    try {
      const token = window.localStorage.getItem("token");
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getInvInfoByID?invId=${encodeURIComponent(invId)}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${token}`,
          },
        },
      );
      const result = await response.json();
      if (result.success && result.data) {
        const d = result.data;
        setSelectedCodeNoInvId(invId);
        setFieldsDisabledByCodeNo(true);
        form.setFieldsValue({
          city: d.locationInfo?.city ?? "",
          area: d.locationInfo?.Area ?? "",
          name: d.locationInfo?.name ?? "",
          mediaType: d.typeOfMediaInfo?.name ?? undefined,
          illu: d.illumination ?? undefined,
          width: d.width ?? undefined,
          height: d.height ?? undefined,
          codeNo: d.codeNo ?? "",
        });
      } else {
        notification.error({
          message: "Error",
          description: result.message || "Failed to load inventory info.",
        });
      }
    } catch (err) {
      notification.error({
        message: "Error",
        description: err.message || "Failed to fetch inventory info.",
      });
    } finally {
      setLoadingInvInfo(false);
    }
  };

  // useEffect(() => {
  //   if (flag) {
  //     handleFileSelectOfPreview();
  //   }
  // }, [flag]);

  // Rewrite the file change handler to directly call the upload function
  const handleFileChange = (event) => {
    console.log("File change triggered");

    // Reset all relevant states first
    setPreviewURLs([]);
    setSelectedFiles([]);
    setImageUrl(null);
    setSelectedImage(null);

    const files = Array.from(event.target.files);
    if (files.length === 0) {
      console.log("No files selected");
      event.target.value = null;
      return;
    }

    const file = files[0];
    console.log("Selected file:", file.name);

    // Process the selected image for preview
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log("File read complete, setting preview image");
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Check file types
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/heic"];

    if (files.some((file) => !allowedTypes.includes(file.type))) {
      notification.error({
        message: "You are only allowed to upload image.",
      });
      event.target.value = null;
      return;
    }

    // Clear the file input value
    event.target.value = null;

    // IMPORTANT: Instead of using flag and useEffect, upload directly
    console.log("Calling uploadFile directly");
    uploadFile(files);
  };

  // Create a new direct upload function
  const uploadFile = async (files) => {
    if (!files || files.length === 0) {
      console.log("No files to upload");
      return;
    }

    console.log("Starting direct upload of files:", files);
    setIsUploading(true);

    try {
      for (const file of files) {
        const fileType = file.type;
        const requestBody = {
          fileName: encodeURIComponent(file.name),
          mime: fileType,
          "Content-Type": fileType,
          acl: "public-read",
        };

        console.log("Uploading file:", file.name);
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Upload policy received:", data);

        if (data?.data?.fields && data?.data?.url) {
          const formData = new FormData();

          // Ensure Content-Type is set correctly for S3 policy
          const expectedContentType = fileType || "image/jpeg";

          Object.entries(data.data.fields).forEach(([key, value]) => {
            // Override Content-Type or mime if present to ensure exact match
            if (
              key.toLowerCase() === "content-type" ||
              key.toLowerCase() === "mime"
            ) {
              formData.append(key, expectedContentType);
            } else {
              formData.append(key, value);
            }
          });

          // Ensure Content-Type is set even if not in fields, but only if mime is also missing
          if (
            !formData.has("Content-Type") &&
            !formData.has("content-type") &&
            !formData.has("mime")
          ) {
            formData.append("Content-Type", expectedContentType);
          }

          formData.append("file", file);

          const uploadResponse = await fetch(data.data.url, {
            method: "POST",
            body: formData,
          });

          if (uploadResponse.ok) {
            const finalUrl = convertS3ToCloudFront(
              `${data.data.url}/${encodeURIComponent(data.filePath)}`,
            );
            console.log("File uploaded successfully to:", finalUrl);
            setImageUrl(finalUrl);
          } else {
            throw new Error(`Upload failed: ${uploadResponse.status}`);
          }
        }
      }
    } catch (error) {
      console.error("Error during upload:", error);
      notification.error({
        message: "Failed to upload image. Please try again.",
      });
      setImageUrl(null);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="add-inventory-container">
      <div className="add-inventory-form">
        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          initialValues={{ remember: true }}
          layout="vertical"
        >
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={12}>
              <Form.Item label="Select Code No">
                <Select
                  placeholder="Select Code No"
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  loading={loadingCodeNos}
                  value={selectedCodeNoInvId || undefined}
                  onChange={(invId) => {
                    setSelectedCodeNoInvId(invId || null);
                    handleCodeNoSelect(invId);
                  }}
                  options={codeNosList.map((item) => ({
                    label: item.CodeNo,
                    value: item._id,
                  }))}
                  style={{ width: "50%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* First Row */}
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label={
                  <span>
                    City <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="city"
                rules={[{ required: true, message: "Please add the city!" }]}
              >
                <Input disabled={fieldsDisabledByCodeNo} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span>
                    Area <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="area"
                rules={[{ required: true, message: "Please add the Area!" }]}
              >
                <Input disabled={fieldsDisabledByCodeNo} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <span>
                    Media Type <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="mediaType"
                rules={[
                  {
                    required: true,
                    message: "Please select the media vehicle!",
                  },
                ]}
              >
                <Select
                  placeholder="Please select"
                  disabled={fieldsDisabledByCodeNo}
                >
                  <Option value="Gantry">Gantry</Option>
                  <Option value="Unipole">Unipole</Option>
                  <Option value="Hoarding">Hoarding</Option>
                  <Option value="Cantilever">Cantilever</Option>
                  <Option value="LED">LED</Option>
                  <Option value="Kiosk">Kiosk</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Second Row */}
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                label={
                  <span>
                    Location <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="name"
                rules={[
                  { required: true, message: "Please add the location!" },
                ]}
              >
                <Input disabled={fieldsDisabledByCodeNo} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <span>
                    ILLUMINATION <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="illu"
                rules={[
                  { required: true, message: "Please select the media Type!" },
                ]}
              >
                <Select
                  placeholder="Please select"
                  disabled={fieldsDisabledByCodeNo}
                >
                  <Option value="FL">FL</Option>
                  <Option value="BL">BL</Option>
                  <Option value="NL">NL</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <div style={{ display: "flex" }} className="add-inventory-third-row">
            <div>
              <div
                className="add-inventory-image-upload"
                style={{ height: "100%", marginTop: "0px" }}
              >
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    style={{
                      width: "200px",
                      minHeight: "200px",
                      objectFit: "cover",
                      border: "2px solid #ccc",
                      borderRadius: "5px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                ) : (
                  "Upload image here"
                )}

                <Button
                  type="primary"
                  shape="circle"
                  icon={<PlusOutlined />}
                  style={{ position: "absolute", top: "80%" }}
                  onClick={handleUpload}
                />
                <input
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  className="imageFile"
                  onChange={handleFileChange}
                />
              </div>
            </div>
            <div>
              <div id="inv-form-inputs">
                <Form.Item
                  label={
                    <span>
                      Width <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="width"
                  rules={[
                    {
                      required: true,
                      message: "Please enter width!",
                    },
                    {
                      pattern: /^\d+(\.\d+)?$/,
                      message: "Please enter numbers only!",
                    },
                  ]}
                >
                  <Input disabled={fieldsDisabledByCodeNo} />
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Height <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="height"
                  rules={[
                    {
                      required: true,
                      message: "Please enter height!",
                    },
                    {
                      pattern: /^\d+(\.\d+)?$/,
                      message: "Please enter numbers only!",
                    },
                  ]}
                >
                  <Input disabled={fieldsDisabledByCodeNo} />
                </Form.Item>
                <Form.Item label="Unit" name="unit" initialValue={1}>
                  <Input disabled />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  label={
                    <span>
                      Latitude <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="lat"
                  rules={[
                    { required: true, message: "Please enter latitude!" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label={
                    <span>
                      Longitude <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="lng"
                  rules={[
                    { required: true, message: "Please enter longitude!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              {/* CAS Code and Code No - not needed; code no is already generated from Select Code No */}
              {/* <div>
                <Form.Item label={<span>CAS Code</span>} name="casCode">
                  <Input />
                </Form.Item>
                <Form.Item
                  label={
                    <span>
                      Code No <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="codeNo"
                  rules={[{ required: true, message: "Please enter Code No!" }]}
                >
                  <Input disabled={fieldsDisabledByCodeNo} />
                </Form.Item>
              </div> */}
              <div>
                {/* <Form.Item
                  label={
                    <span>
                      Owned by <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="ownedBy"
                  rules={[
                    { required: true, message: "Please enter Owned by!" },
                  ]}
                >
                  <Input />
                </Form.Item> */}
                <Form.Item
                  label={
                    <span>
                      Rate per month <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="ratePerMonth"
                  rules={[
                    { required: true, message: "Please enter rate per month!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div style={{ display: "flex", gap: "1rem" }}>
                <Form.Item label={<span>Suffix</span>} name="suffix">
                  <Select placeholder="Please select suffix" allowClear>
                    <Option value="HO">HO</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label={
                    <span>
                      Zone <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="zone"
                  rules={[
                    {
                      required: true,
                      message: "Please select the zone!",
                    },
                  ]}
                >
                  <Select placeholder="Please select zone">
                    <Option value="Centre">Centre</Option>
                    <Option value="East">East</Option>
                    <Option value="West">West</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
          </div>
          <br />
          <Form.Item style={{ marginBottom: 0 }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={!selectedCodeNoInvId}
              >
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
